import { render, staticRenderFns } from "./StudyDatasetSummary.vue?vue&type=template&id=b508eb46&scoped=true"
import script from "./StudyDatasetSummary.vue?vue&type=script&lang=js"
export * from "./StudyDatasetSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b508eb46",
  null
  
)

export default component.exports